import React from "react";

export default function CompanyName({ register, errors }) {
  const fieldName = "companyname";

  return (
    <div>
      <label className="wdc-field-label" htmlFor={fieldName}>
        Company / business name
      </label>
      <input
        id={fieldName}
        className="wdc-field"
        placeholder="Enter company name"
        {...register(fieldName, { required: true })}
      />
      {errors[fieldName] && (
        <span className="wdc-error">This field is required</span>
      )}
    </div>
  );
}
